/*
 * PAWS & PEARLS — CANDY DREAMS | DISSOLVING GARDEN CURTAIN v1
 * 24 October 2026 — TEST THEME, pending Madam's approval
 * On Candy Dreams ONLY. Full-cover silk-effect curtain hides the original Hero.
 * Visitor's entrance click starts the existing Sugar Plum Fairy MP3 within
 * the active click gesture if House Sound is ON. Single playback, no loop.
 * After a soft dissolve, loads exactly the ORIGINAL, UNMODIFIED approved
 * rose v1, vine v3 and falling petals v2 animation JS files.
 * IMPORTANT: the old THREE botanical + old Sugar Plum v3 script *tags* must be
 * replaced with ONE controller script tag containing the three data-* sources.
 * Those existing asset files must remain in Assets, untouched, for rollback.
 * No other pages, House Sound controls or rare events are altered.
 */
(function () {
  'use strict';
  if (!/^\/collections\/candy-dreams\/?$/i.test(window.location.pathname)) return;
  var INSTANCE_KEY = '__ppCandyDreamsDissolvingCurtainV1';
  if (window[INSTANCE_KEY]) return;

  var selfTag = document.currentScript;
  var scripts = selfTag ? [
    selfTag.getAttribute('data-rose-src'),
    selfTag.getAttribute('data-vine-src'),
    selfTag.getAttribute('data-petals-src')
  ] : [];
  if (scripts.length !== 3 || scripts.some(function (src) { return !src || !/\.js(?:[?#]|$)/i.test(src); })) {
    console.warn('[P&P Candy Curtain] The three original botanical script sources are required.');
    return;
  }
  window[INSTANCE_KEY] = true;

  var MUSIC_URL = 'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/Dance_20of_20the_20Sugar_20Plum_20Fairy.mp3?v=1792832359';
  var ATLAS_URLS = [
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/pp-candy-garden-hanging-rose-12frame-atlas-v1.webp?v=1792827462',
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/pp-candy-garden-climbing-pink-vine-7frame-atlas-v1.webp?v=1792828692',
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/pp-candy-garden-falling-petals-6sprite-atlas-v1.webp?v=1792830894'
  ];
  var audio = new Audio(MUSIC_URL);
  audio.preload = 'auto';
  audio.loop = false;
  audio.volume = 0.8;

  var entered = false;
  var finished = false;
  var curtain = null;
  var musicStarted = false;
  var musicRequest = 0;
  var gardenLoaded = false;

  function houseSoundEnabled() {
    var house = window.ppHouseSound;
    return !!(house && typeof house.isEnabled === 'function' && house.isEnabled());
  }
  function pauseAndFinishMusic() {
    if (finished) return;
    finished = true;
    ++musicRequest;
    try { audio.pause(); } catch (_) {}
  }
  function tryMusic() {
    if (!entered || finished || !houseSoundEnabled() || !audio.paused) return;
    // Called INSIDE the trusted Enter button click (or House Sound toggle).
    var serial = ++musicRequest;
    try {
      var result = audio.play();
      if (result && typeof result.then === 'function') {
        result.then(function () {
          if (serial !== musicRequest || finished || !houseSoundEnabled()) {
            try { audio.pause(); } catch (_) {}
          } else { musicStarted = true; }
        }).catch(function (error) {
          if (serial === musicRequest) {
            console.info('[P&P Candy Curtain] Browser prevented soundtrack playback:', error && error.name);
          }
        });
      } else { musicStarted = true; }
    } catch (error) {
      console.info('[P&P Candy Curtain] Soundtrack unavailable:', error && error.name);
    }
  }
  function onHouseSoundChange() {
    if (!entered || finished) return;
    if (!houseSoundEnabled()) {
      // House Sound OFF ends this one-time presentation soundtrack.
      if (musicStarted || !audio.paused) pauseAndFinishMusic();
    } else if (audio.paused) {
      // House Sound toggle dispatches during the existing user control gesture.
      tryMusic();
    }
  }
  audio.addEventListener('ended', pauseAndFinishMusic, {once:true});
  window.addEventListener('pp:house-sound-change', onHouseSoundChange);
  window.addEventListener('pagehide', pauseAndFinishMusic, {once:true});
  window.addEventListener('popstate', function () {
    if (!/^\/collections\/candy-dreams\/?$/i.test(window.location.pathname)) pauseAndFinishMusic();
  });

  function locateHero() {
    var divider = document.querySelector('.pp-candy-floral-divider');
    if (!divider) return null;
    var dividerSection = divider.closest('[id^="shopify-section-"]') || divider.closest('.shopify-section');
    if (!dividerSection) return null;
    var hero = dividerSection.nextElementSibling;
    if (!hero || !hero.matches('[id^="shopify-section-"], .shopify-section') ||
        !hero.querySelector('img, picture, video')) return null;
    return hero;
  }

  function preloadGardenImages() {
    ATLAS_URLS.forEach(function (url) { var image = new Image(); image.src = url; });
    // Preloading original script assets avoids introducing extra choreography lag.
    scripts.forEach(function (src) {
      var link = document.createElement('link');
      link.rel = 'preload'; link.as = 'script'; link.href = src;
      document.head.appendChild(link);
    });
  }

  function startOriginalGarden() {
    if (gardenLoaded) return;
    gardenLoaded = true;
    scripts.forEach(function (src) {
      var child = document.createElement('script');
      child.src = src;
      child.async = false;
      child.dataset.ppCandyCurtainChild = 'v1';
      child.onerror = function () {
        console.warn('[P&P Candy Curtain] Could not load original garden script:', src);
      };
      document.body.appendChild(child);
    });
  }

  function enterGarden() {
    if (entered) return;
    entered = true;
    // MUST remain synchronous in button's trusted user click: Safari requires it.
    tryMusic();

    var motionReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (curtain) {
      curtain.classList.add('pp-candy-curtain--dissolving');
      var clickSurface = curtain.querySelector('button');
      if (clickSurface) { clickSurface.disabled = true; clickSurface.blur(); }
      window.setTimeout(function () {
        if (curtain && curtain.parentNode) curtain.remove();
      }, motionReduced ? 90 : 1670);
    }
    // The rose begins its own 600 ms delay AFTER the silk is nearly transparent.
    // Original rose (0.6s), vine (5.8s), petals (12s) timing untouched.
    window.setTimeout(startOriginalGarden, motionReduced ? 0 : 1120);
  }

  function installStyles() {
    if (document.getElementById('pp-candy-dissolving-curtain-style-v1')) return;
    var style = document.createElement('style');
    style.id = 'pp-candy-dissolving-curtain-style-v1';
    style.textContent = [
      '.pp-candy-curtain-v1{position:absolute!important;inset:0!important;z-index:35!important;overflow:hidden!important;isolation:isolate;box-sizing:border-box;opacity:1;filter:none;transform:translateZ(0);}',
      '.pp-candy-curtain-v1__button{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;min-height:100%!important;margin:0!important;padding:clamp(12px,2vw,28px)!important;box-sizing:border-box!important;display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:clamp(8px,1.3vw,17px)!important;border:0!important;border-radius:0!important;box-shadow:none!important;cursor:pointer!important;-webkit-appearance:none!important;appearance:none!important;text-align:center!important;color:#7a514d!important;font-family:Georgia,"Times New Roman",serif!important;touch-action:pan-y;background-color:#f9efeb!important;',
      /* Folded-silk effect: opaque base ensures the hero is genuinely hidden. */
      'background-image:radial-gradient(ellipse 50% 78% at 50% 44%,rgba(255,255,255,.72) 0%,rgba(255,249,245,.20) 75%,rgba(204,141,137,.16) 100%),repeating-linear-gradient(90deg,rgba(126,71,83,.035) 0%,rgba(255,255,255,.16) 4%,rgba(247,217,214,.26) 9%,rgba(178,112,113,.10) 15%,rgba(255,255,255,.20) 22%,rgba(136,78,84,.028) 28%),linear-gradient(115deg,#efdad8 0%,#fff7f2 38%,#f4e7e5 67%,#e7cfca 100%)!important;',
      'background-position:center!important;background-size:cover!important;}',
      '.pp-candy-curtain-v1__button::before{content:"";position:absolute;inset:clamp(12px,2.7vw,38px);border:1px solid rgba(177,115,110,.45);box-shadow:inset 0 0 0 7px rgba(255,255,255,.16),0 0 25px rgba(233,193,185,.14);border-radius:1px;pointer-events:none;}',
      '.pp-candy-curtain-v1__button::after{content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(90deg,rgba(158,96,100,.06),transparent 23%,transparent 77%,rgba(158,96,100,.08)),repeating-linear-gradient(90deg,transparent 0%,rgba(255,255,255,.10) 7%,transparent 13%,rgba(142,72,90,.025) 21%,transparent 27%);mix-blend-mode:multiply;}',
      '.pp-candy-curtain-v1__eyebrow,.pp-candy-curtain-v1__title,.pp-candy-curtain-v1__subtitle,.pp-candy-curtain-v1__action{position:relative;z-index:1;max-width:90%;margin:0!important;padding:0!important;color:inherit!important;text-shadow:0 1px 2px rgba(255,255,255,.7);}',
      '.pp-candy-curtain-v1__eyebrow{font:400 clamp(10px,1.05vw,14px)/1.5 Georgia,"Times New Roman",serif!important;letter-spacing:clamp(.10em,.3vw,.31em)!important;text-transform:uppercase;}',
      '.pp-candy-curtain-v1__ornament{position:relative;z-index:1;display:block;width:clamp(100px,18vw,235px);height:18px;background:linear-gradient(to right,transparent,rgba(164,107,102,.75),transparent) center/100% 1px no-repeat;}',
      '.pp-candy-curtain-v1__ornament::after{content:"✧";position:absolute;left:50%;top:50%;transform:translate(-50%,-52%);padding:0 12px;font:normal 22px Georgia,serif;color:#ae7775;background:rgba(251,240,236,.92);}',
      '.pp-candy-curtain-v1__title{font:400 clamp(30px,5.15vw,76px)/1.12 Georgia,"Times New Roman",serif!important;letter-spacing:clamp(.015em,.1vw,.06em)!important;color:#79514d!important;}',
      '.pp-candy-curtain-v1__subtitle{font:italic 400 clamp(13px,1.47vw,21px)/1.5 Georgia,"Times New Roman",serif!important;letter-spacing:.03em!important;color:#92706b!important;}',
      '.pp-candy-curtain-v1__action{display:inline-flex;align-items:center;justify-content:center;margin-top:clamp(8px,1.6vw,25px)!important;padding:10px clamp(18px,3.2vw,40px)!important;border:1px solid rgba(163,105,102,.64);border-radius:999px;letter-spacing:.20em!important;text-transform:uppercase;font:400 clamp(10px,1.0vw,14px)/1.7 Georgia,"Times New Roman",serif!important;color:#774e4d!important;background:rgba(255,255,255,.49);transition:background .2s ease,box-shadow .2s ease;}',
      '.pp-candy-curtain-v1__button:hover .pp-candy-curtain-v1__action{background:rgba(255,255,255,.82);box-shadow:0 5px 20px rgba(156,105,107,.15);}',
      '.pp-candy-curtain-v1__button:focus-visible{outline:4px solid #876263!important;outline-offset:-7px!important;}',
      '.pp-candy-curtain-v1.pp-candy-curtain--dissolving{animation:pp-candy-curtain-mist-away 1.6s cubic-bezier(.28,.03,.4,1) both;pointer-events:none!important;}',
      '@keyframes pp-candy-curtain-mist-away{0%{opacity:1;filter:blur(0px);transform:scale(1)}32%{opacity:.97;filter:blur(1px);transform:scale(1.002)}70%{opacity:.46;filter:blur(8px);transform:scale(1.013)}100%{opacity:0;filter:blur(19px);transform:scale(1.035)}}',
      '@media(max-width:749px){.pp-candy-curtain-v1__button{gap:6px!important;padding:11px!important}.pp-candy-curtain-v1__eyebrow{letter-spacing:.13em!important}.pp-candy-curtain-v1__button::before{inset:10px}.pp-candy-curtain-v1__ornament{height:12px}.pp-candy-curtain-v1__subtitle{max-width:75%;font-size:clamp(12px,3vw,15px)!important}.pp-candy-curtain-v1__action{margin-top:4px!important;padding:6px 14px!important;letter-spacing:.12em!important}}',
      '@media(prefers-reduced-motion:reduce){.pp-candy-curtain-v1.pp-candy-curtain--dissolving{animation:none;opacity:0;pointer-events:none}.pp-candy-curtain-v1__action{transition:none}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function mount() {
    if (entered) return;
    var hero = locateHero();
    if (!hero || hero.querySelector('.pp-candy-curtain-v1')) return;
    if (window.getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
    installStyles();
    var veil = document.createElement('div');
    veil.className = 'pp-candy-curtain-v1';
    veil.setAttribute('data-pp-candy-entrance-curtain', 'v1');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'pp-candy-curtain-v1__button';
    button.setAttribute('aria-label', 'Enter Candy Dreams and reveal the garden');
    button.innerHTML = '<span class="pp-candy-curtain-v1__eyebrow">A secret garden awaits</span>' +
      '<span aria-hidden="true" class="pp-candy-curtain-v1__ornament"></span>' +
      '<span class="pp-candy-curtain-v1__title">Candy Dreams</span>' +
      '<span class="pp-candy-curtain-v1__subtitle">A little wonder is about to unfold</span>' +
      '<span class="pp-candy-curtain-v1__action">Enter the garden</span>';
    button.addEventListener('click', enterGarden);
    veil.appendChild(button);
    hero.appendChild(veil);
    curtain = veil;
    preloadGardenImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, {once:true});
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', function () {
    if (!entered) window.requestAnimationFrame(mount);
  });
})();
